import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { dataActions } from "@src/services/state/dataReducer";

import { useDataState } from "./data";

/**
 * Hook for managing per-exchange symbol names cache in Redux
 * Only stores symbol names (not full objects) for fast dropdown loading
 */
export const useExchangeSymbols = () => {
  const dispatch = useDispatch();
  const exchangeSymbols = useDataState((state) => state.exchangeSymbols);

  const getSymbolNamesForExchange = useCallback(
    (exchange: string): string[] | null => {
      return exchangeSymbols[exchange] || null;
    },
    [exchangeSymbols],
  );

  const setSymbolNamesForExchange = useCallback(
    (exchange: string, names: string[]) => {
      dispatch(dataActions.setExchangeSymbolNames({ exchange, names }));
    },
    [dispatch],
  );

  const hasSymbolsForExchange = useCallback(
    (exchange: string): boolean => {
      return exchange in exchangeSymbols;
    },
    [exchangeSymbols],
  );

  return {
    exchangeSymbols,
    getSymbolNamesForExchange,
    setSymbolNamesForExchange,
    hasSymbolsForExchange,
  };
};
